import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrfpr4vzca: FaireProductEntity = {
  token: "p_rrfpr4vzca",
  type: "product",
  name: "Mini Fish candles",
  brandToken: "b_2t69ysb2gm",
  brandName: "Woven",
  imageUrl:
    "https://cdn.faire.com/fastly/fc22d3d8f378fbaaf8c080c39bcfefef2ac9fa28e069d7451cb3db67f88d8713.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d97c31319a19d1b5c777241c7cfb5bbf2715ef82d0d51a0c2450eb070c55907.jpeg",
  ],
  priceDollars: 1.47,
  description:
    "Our Mini Fish candles, a unique addition to our Novelty Candle line, are  hand-poured on Cortes Island, Great for ontop a birthday cake ",
  tags: [],
  msrpDollars: 2.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:43.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
